import SimpleReactValidator from 'shared/utils/simple-react-validator';
import { createSlice } from '@reduxjs/toolkit';

import defaultState from 'wave_solder_pallets/data/defaultState';
import { QUOTING, QUOTED, ERROR } from 'shared/data/quoteSteps';
import { columnSelected, rowSelected } from 'wave_solder_pallets/data/parameters';
import { addToCart, doQuote } from 'wave_solder_pallets/store/thunks';

export const validator = new SimpleReactValidator();

const wspSlice = createSlice({
  name: 'wsp',
  initialState: defaultState,
  reducers: {
    changeParameter(state, action) {
      const { name, value } = action.payload;
      state.parameters[name] = value;
      state.parameters.row_selected = rowSelected(state.parameters);
      state.parameters.column_selected = columnSelected(state.parameters);
    },
    updateQuantity(state, action) {
      state.quantity = action.payload;
    },
    updateValidatorFlag(state) {
      state.validatorFlag = !state.validatorFlag;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doQuote.pending, (state) => {
        state.quoteStep = QUOTING;
      })
      .addCase(doQuote.fulfilled, (state, action) => {
        const quote = action.payload;
        state.quoteStep = QUOTED;

        state.quote.line_items = quote.line_items;
        state.quote.number = quote.number;
        state.quote.variant_id = quote.variant_id;
        state.quote.product_name = quote.product_name;

        state.parameters.product_quote_number = quote.number;
      })
      .addCase(doQuote.rejected, (state) => {
        state.quoteStep = ERROR;
      })
      .addCase(addToCart.pending, (state) => {
        state.addingToCart = true;
      })
      .addCase(addToCart.rejected, (state) => {
        state.addingToCart = false;
      });
  },
});

export const {
  changeParameter,
  updateQuantity,
  updateValidatorFlag,
} = wspSlice.actions;

export default wspSlice.reducer;
